const moduleSelector = '.locations';

/**
 * Module Init – Tab switching with stacked card slide animation
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((section) => {
    const tabsContainer = section.querySelector('.locations__map__tabs');
    const contentContainer = section.querySelector('.locations__map__content');
    if (!tabsContainer || !contentContainer) return;

    const tabs = tabsContainer.querySelectorAll('.locations__map__tabs__btn');
    const cards = contentContainer.querySelectorAll('.locations__map__card');
    if (!tabs.length || !cards.length) return;

    let isAnimating = false;

    tabs.forEach((btn) => {
      btn.addEventListener('click', () => {
        const newIndex = btn.dataset.index;
        const currentActive = contentContainer.querySelector('.locations__map__card.active');

        if (!currentActive || currentActive.dataset.index === newIndex || isAnimating) return;
        isAnimating = true;

        const nextCard = contentContainer.querySelector(`.locations__map__card[data-index="${newIndex}"]`);

        // Update tab active state
        tabsContainer.querySelector('.locations__map__tabs__btn.active')?.classList.remove('active');
        btn.classList.add('active');

        // Outgoing card: slides out to the right
        currentActive.classList.add('to-back');

        // At midpoint (card is offscreen), bring incoming card to front
        setTimeout(() => {
          currentActive.classList.remove('active');
          nextCard.classList.add('active');
        }, 300);

        // After animation ends, clean up
        currentActive.addEventListener('animationend', () => {
          currentActive.classList.remove('to-back');
          isAnimating = false;
        }, { once: true });
      });
    });
  });
})();
